import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const TableCell = styled.div(props => ({
  display: 'flex',
  justifyContent: props.center ? 'center' : 'flex-start'
}))

export const PriorityTag = styled.div({
  '&.priority.urgent': {
    background: '#FF0000',
    borderRadius: '2px',
    color: '#FFF',
    fontWeight: 'bold',
    padding: '2px 5px',
  }
})

export const RowFields = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',
  },
})
